// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"f0ad45b2","71":"a50858b5","189":"384bf65e","190":"85a8eb26","243":"a869974e","328":"9227f237","342":"ac562418","390":"ab142b1a","448":"3e750e8b","511":"2c14d9a5","580":"699441ac","669":"44ab2341","791":"3abb5e4a"}[chunkId] + ".chunk.js";
};